/*eslint quote-props: ["error", "always"]*/

const links = {
  "integration.forward_logs_to": "Forward logs from your project to {name}",
  "integration.forward_logs_to_newrelic":
    "Forward logs from your project to New Relic",
  "link.application_metrics_increase_observability":
    "https://docs.upsun.com/anchors/fixed/observability/metrics/infrastructure/",
  "links.CLI_download": "https://platform.sh/cli/installer",
  "links.CLI_download.osx_linux": "platformsh/tap/platformsh-cli",
  "links.CLI_download.windows":
    "https://github.com/platformsh/homebrew-tap.git",
  "links.CLI_repository": "https://docs.upsun.com/anchors/fixed/cli/",
  "links.api.docs": "https://developer.upsun.com/api",
  "links.aup": "https://upsun.com/trust-center/legal/aup/",
  "links.blackfire.connect": "https://blackfire.io/session/connect/platformsh",
  "links.blackfire.features": "https://www.blackfire.io/features",
  "links.blackfire.pricing": "https://www.blackfire.io/pricing",
  "links.chat.channel": "https://community.upsun.com/",
  "links.community.featureroadmap":
    "https://developer.upsun.com/posts/articles/releases",
  "links.community.questions_answers":
    "https://support.platform.sh/hc/en-us/search?query=questions-answers&type=community",
  "links.community.requestfeature":
    "https://developer.upsun.com/posts/articles/releases",
  "links.community.tutorial":
    "https://support.platform.sh/hc/en-us/search?query=tutorial&type=community",
  "links.community.view_all": "https://devcenter.upsun.com/changelog/",
  "links.contact": "https://upsun.com/contact-us/",
  "links.demo_project_git_url": "https://github.com/upsun/demo.git",
  "links.documentation": "https://fixed.docs.upsun.com/",
  "links.documentation.CLI": "https://docs.upsun.com/anchors/fixed/cli/",
  "links.documentation.CLI_API_token":
    "https://docs.upsun.com/anchors/fixed/cli/api-token/",
  "links.documentation.SSH": "https://docs.upsun.com/anchors/fixed/ssh/keys/",
  "links.documentation.SSH_keys":
    "https://docs.upsun.com/anchors/fixed/ssh/keys/",
  "links.documentation.WCAG": "https://upsun.com/trust-center/legal/",
  "links.documentation.access":
    "https://docs.upsun.com/anchors/fixed/console/project/access/",
  "links.documentation.active_environment":
    "https://docs.upsun.com/anchors/fixed/environments/status/",
  "links.documentation.add_ssh_keys":
    "https://docs.upsun.com/anchors/fixed/ssh/keys/add/",
  "links.documentation.admin_backups":
    "https://docs.upsun.com/anchors/fixed/environments/backup/schedule/",
  "links.documentation.administration.servers":
    "https://docs.upsun.com/anchors/fixed/administration/servers/",
  "links.documentation.app":
    "https://docs.upsun.com/anchors/fixed/app/configure/",
  "links.documentation.app.storage_mounts":
    "https://docs.upsun.com/anchors/fixed/app/reference/mounts/",
  "links.documentation.app.timezone":
    "https://docs.upsun.com/anchors/fixed/app/timezone/",
  "links.documentation.app.variables":
    "https://docs.upsun.com/anchors/fixed/variables/",
  "links.documentation.apps_and_services_setup":
    "https://docs.upsun.com/create-apps.html",
  "links.documentation.automated_updates":
    "https://docs.upsun.com/anchors/fixed/reference/automated-updates/",
  "links.documentation.autoscaling":
    "https://docs.upsun.com/manage-resources/autoscaling.html",
  "links.documentation.availability_incident_handling_procedure":
    "https://docs.upsun.com/anchors/fixed/dedicated/security/monitoring/",
  "links.documentation.backups":
    "https://docs.upsun.com/anchors/fixed/security/backup-restore/",
  "links.documentation.backups_schedule":
    "https://docs.upsun.com/anchors/fixed/security/data-retention/grid-backups/",
  "links.documentation.cache":
    "https://docs.upsun.com/anchors/fixed/routes/cache/",
  "links.documentation.carbon_emissions":
    "https://docs.upsun.com/anchors/fixed/regions/carbon-calculation/",
  "links.documentation.configure_project":
    "https://docs.upsun.com/anchors/fixed/console/project/",
  "links.documentation.configure_project.certificates":
    "https://docs.upsun.com/anchors/fixed/console/project/certificates/",
  "links.documentation.configure_resources.object_storage":
    "https://developer.upsun.com/docs/manage-resources/object-storage",
  "links.documentation.container_configuration":
    "https://docs.upsun.com/anchors/fixed/app/reference/root-keys/",
  "links.documentation.container_log":
    "https://docs.upsun.com/anchors/fixed/observability/logs/container/",
  "links.documentation.container_profiles":
    "https://docs.upsun.com/anchors/fixed/app/reference/size/container-profile/",
  "links.documentation.core-concepts.structure.router":
    "https://developer.upsun.com/docs/core-concepts/structure#router",
  "links.documentation.create_apps":
    "https://docs.upsun.com/anchors/fixed/app/configure/",
  "links.documentation.create_new_project":
    "https://docs.upsun.com/anchors/fixed/project/migrate/",
  "links.documentation.dedicated_cluster":
    "https://docs.upsun.com/anchors/fixed/dedicated/",
  "links.documentation.define_routes":
    "https://docs.upsun.com/anchors/fixed/routes/",
  "links.documentation.deploy.commit":
    "https://docs.upsun.com/anchors/fixed/start/commit/",
  "links.documentation.deploy_key":
    "https://docs.upsun.com/anchors/fixed/console/project/deploy-key/",
  "links.documentation.dns":
    "https://docs.upsun.com/anchors/fixed/domains/dns/",
  "links.documentation.domain":
    "https://docs.upsun.com/anchors/fixed/domains/custom/",
  "links.documentation.domain.flex":
    "https://docs.upsun.com/anchors/domains/custom/",
  "links.documentation.download_code":
    "https://docs.upsun.com/anchors/fixed/development/local/download-code/",
  "links.documentation.endpoint":
    "https://search.fixed.docs.upsun.com/indexes/platform_docs/search",
  "links.documentation.environment_search_engine_visibility":
    "https://docs.upsun.com/anchors/fixed/search-engine-visibility/",
  "links.documentation.environment_search_engine_visibility.how_its_done":
    "https://developer.upsun.com/docs/environments/search-engine-visibility#how-it%E2%80%99s-done",
  "links.documentation.environments.backup":
    "https://docs.upsun.com/anchors/fixed/environments/backup/",
  "links.documentation.environments.backup.manual_backups":
    "https://docs.upsun.com/anchors/fixed/environments/backup/manual/",
  "links.documentation.environments.backup.multiple_automated_schedules":
    "https://docs.upsun.com/anchors/fixed/environments/backup/configure/multiple/",
  "links.documentation.environments.backup.set_backup_limit":
    "https://docs.upsun.com/anchors/fixed/environments/backup/maximum/",
  "links.documentation.environments.cancel_activity":
    "https://docs.upsun.com/anchors/fixed/environments/cancel-activity/",
  "links.documentation.environments.default_environment":
    "https://docs.upsun.com/anchors/fixed/environments/default/rename/",
  "links.documentation.flexible_resources":
    "https://docs.upsun.com/anchors/fixed/app/flexible-resources/",
  "links.documentation.getting_started":
    "https://docs.upsun.com/anchors/fixed/reference/start/",
  "links.documentation.getting_started_CLI":
    "https://docs.upsun.com/anchors/fixed/cli/",
  "links.documentation.going_live":
    "https://docs.upsun.com/anchors/fixed/domains/custom/",
  "links.documentation.help.CLI": "https://docs.upsun.com/anchors/fixed/cli/",
  "links.documentation.homepage": "https://fixed.docs.upsun.com",
  "links.documentation.hsts":
    "https://docs.upsun.com/anchors/fixed/routes/https/tls/hsts/",
  "links.documentation.inactive_environment":
    "https://docs.upsun.com/anchors/fixed/glossary/inactive-environment/",
  "links.documentation.integrations":
    "https://docs.upsun.com/anchors/fixed/integrations/",
  "links.documentation.integrations.activity":
    "https://docs.upsun.com/anchors/fixed/integrations/activity-scripts/",
  "links.documentation.integrations.activity_scripts":
    "https://docs.upsun.com/anchors/fixed/integrations/activity-scripts/configure/",
  "links.documentation.integrations.github":
    "https://docs.upsun.com/anchors/fixed/integrations/source/github/",
  "links.documentation.integrations.source":
    "https://docs.upsun.com/anchors/fixed/integrations/source/",
  "links.documentation.learn.deployment_type":
    "https://docs.upsun.com/learn/overview/build-deploy.html#deployment-types",
  "links.documentation.learn.maintenance-window":
    "https://docs.upsun.com/learn/overview/build-deploy.html#maintenance-window",
  "links.documentation.learn.manual_deployment":
    "https://docs.upsun.com/learn/overview/build-deploy.html#manual-deployment",
  "links.documentation.learn.zero-downtime-deployments":
    "https://docs.upsun.com/anchors/reference/build-deploy/zero-downtime/",
  "links.documentation.live_backups":
    "https://docs.upsun.com/anchors/fixed/environments/backup/live/",
  "links.documentation.manage_resources.environment.sync": "#",
  "links.documentation.manage_resources.horizontal_scaling":
    "https://docs.upsun.com/anchors/resources/configure/scaling/horizontal/",
  "links.documentation.manage_resources.how":
    "https://docs.upsun.com/anchors/resources/manage/how/",
  "links.documentation.metric":
    "https://docs.upsun.com/anchors/fixed/observability/metrics/infrastructure/",
  "links.documentation.metrics.dedicated":
    "https://docs.upsun.com/anchors/fixed/observability/metrics/infrastructure/dedicated/",
  "links.documentation.metrics.grid":
    "https://docs.upsun.com/anchors/fixed/observability/metrics/infrastructure/grid/",
  "links.documentation.migrating_tutorial":
    "https://docs.upsun.com/anchors/fixed/migrate/",
  "links.documentation.mtls":
    "https://docs.upsun.com/anchors/fixed/routes/https/tls/mtls/",
  "links.documentation.mysql_import_data":
    "https://docs.upsun.com/anchors/fixed/services/mysql/import-data/",
  "links.documentation.organization_type":
    "https://fixed.docs.upsun.com/administration/organizations.html#fixed-and-flex-organizations",
  "links.documentation.organizations":
    "https://docs.upsun.com/anchors/fixed/administration/organizations/settings/",
  "links.documentation.organizations.manage-your-organization-users":
    "https://docs.upsun.com/anchors/fixed/administration/users/organization/",
  "links.documentation.own_code_project_configuration":
    "https://docs.upsun.com/anchors/fixed/project/migrate/",
  "links.documentation.paused_crons":
    "https://docs.upsun.com/anchors/fixed/app/reference/cron/paused/",
  "links.documentation.paused_environment":
    "https://docs.upsun.com/anchors/fixed/environments/paused/",
  "links.documentation.postgres_import_data":
    "https://docs.upsun.com/anchors/fixed/services/postgresql/import-data/",
  "links.documentation.pressure_metrics":
    "https://docs.kernel.org/accounting/psi.html",
  "links.documentation.pricing":
    "https://docs.upsun.com/anchors/fixed/administration/pricing/",
  "links.documentation.profiling.dashboard":
    "https://docs.upsun.com/increase-observability/application-metrics/cont-prof.html",
  "links.documentation.profiling.golang":
    "https://docs.upsun.com/increase-observability/application-metrics/go.html",
  "links.documentation.profiling.java":
    "https://docs.upsun.com/increase-observability/application-metrics/java.html",
  "links.documentation.profiling.nodejs":
    "https://docs.upsun.com/increase-observability/application-metrics/nodejs.html",
  "links.documentation.profiling.php":
    "https://docs.upsun.com/increase-observability/application-metrics/php.html",
  "links.documentation.profiling.python":
    "https://docs.upsun.com/increase-observability/application-metrics/python.html",
  "links.documentation.profiling.ruby":
    "https://docs.upsun.com/increase-observability/application-metrics/ruby.html",
  "links.documentation.profiling.rust":
    "https://docs.upsun.com/increase-observability/application-metrics/rust.html",
  "links.documentation.redeploy":
    "https://docs.upsun.com/anchors/fixed/troubleshoot/force-redeploy/",
  "links.documentation.resources":
    "https://docs.upsun.com/anchors/fixed/environments/scale/",
  "links.documentation.resources.configuration":
    "https://docs.upsun.com/anchors/resources/configure/",
  "links.documentation.resources.configuration.advanced_container_profiles":
    "https://docs.upsun.com/anchors/resources/manage/configuration/profiles/advanced/",
  "links.documentation.routes": "https://docs.upsun.com/anchors/fixed/routes/",
  "links.documentation.routes_SSI":
    "https://docs.upsun.com/anchors/fixed/routes/server-side-includes/",
  "links.documentation.runtime_operations":
    "https://docs.upsun.com/anchors/fixed/app/runtime-operations/",
  "links.documentation.services":
    "https://docs.upsun.com/anchors/fixed/services/",
  "links.documentation.settings.variables.variable.prefix":
    "https://docs.upsun.com/anchors/fixed/variables/prefix/",
  "links.documentation.source_operations":
    "https://docs.upsun.com/anchors/fixed/app/source-operations/",
  "links.documentation.subdomain":
    "https://docs.upsun.com/anchors/fixed/domains/subdomains/",
  "links.documentation.tasks":
    "https://developer.upsun.com/docs/configure-apps/tasks",
  "links.documentation.teams":
    " https://docs.upsun.com/anchors/fixed/administration/teams/",
  "links.documentation.tether":
    "https://docs.upsun.com/anchors/fixed/reference/start/local/tethered/",
  "links.documentation.tls_min_version":
    "https://docs.upsun.com/anchors/fixed/routes/https/tls/enforce-13/",
  "links.documentation.troubleshoot_activity":
    "https://docs.upsun.com/development/502-errors.html#step-3-review-recent-activity",
  "links.documentation.troubleshoot_development":
    "https://docs.upsun.com/development/troubleshoot.html",
  "links.documentation.troubleshoot_logs":
    "https://docs.upsun.com/development/502-errors.html#step-1-check-logs-for-troubleshooting-insights",
  "links.documentation.troubleshoot_service_connectivity":
    "https://docs.upsun.com/development/502-errors.html#step-5-verify-service-connectivity",
  "links.documentation.troubleshoot_ssh":
    "https://docs.upsun.com/development/502-errors.html#step-4-ssh-into-the-running-container",
  "links.documentation.troubleshoot_start_command":
    "https://docs.upsun.com/development/502-errors.html#step-2-ensure-your-apps-web-start-command-is-running",
  // Interim target, agreed on CON-1624 so the ticket is not held up waiting for
  // the permanent page. Swap the URL here when that lands.
  "links.documentation.troubleshooting_agent":
    "https://developer.upsun.com/docs/get-started/ai/upsun-troubleshooting-agent",
  "links.documentation.trustcenter":
    "https://docs.upsun.com/anchors/trust-center/",
  "links.documentation.understanding_metrics":
    "https://docs.upsun.com/anchors/fixed/observability/metrics/infrastructure/understand/",
  "links.documentation.usermanagementadddon":
    "https://docs.upsun.com/anchors/billing/add-ons/advanced-user-management/",
  "links.documentation.users":
    "https://docs.upsun.com/anchors/fixed/administration/users/",
  "links.documentation.variables":
    "https://docs.upsun.com/anchors/fixed/variables/",
  "links.documentation.variables.run_and_build_time":
    "https://docs.upsun.com/anchors/fixed/variables/types/",
  "links.documentation.variables.variable_options":
    "https://docs.upsun.com/development/variables/set-variables.html#variable-options",
  "links.documentation.wizard":
    "https://docs.upsun.com/anchors/fixed/reference/start/",
  "links.documentation.workers":
    "https://docs.upsun.com/anchors/fixed/app/workers/",
  "links.documentation.yaml_config_guidance":
    "https://developer.upsun.com/docs/get-started/here/configure",
  "links.documentation.yaml_configuration":
    "https://docs.upsun.com/anchors/fixed/reference/yaml/",
  "links.domains.replacement":
    "https://docs.upsun.com/anchors/fixed/domains/custom/",
  "links.domains.replacement.flex":
    "https://docs.upsun.com/anchors/domains/custom/",
  "links.fixed.pricing": "https://upsun.com/pricing-fixed",
  "links.images.migration":
    "https://docs.upsun.com/anchors/reference/migrate-runtimes-services/",
  "links.log_forwarding_documentation":
    "https://docs.upsun.com/anchors/fixed/observability/logs/forwarding/",
  "links.manage.resources.adjust.resources":
    "https://docs.upsun.com/anchors/resources/manage/configuration/",
  "links.manage.resources.init":
    "https://docs.upsun.com/anchors/resources/manage/init/",
  "links.manage.resources.init.define.strategy":
    "https://docs.upsun.com/anchors/resources/manage/init/define/",
  "links.manage.resources.init.min.resources":
    "https://docs.upsun.com/anchors/resources/manage/init/minimum/",
  "links.observability-suite-blackfire":
    "https://docs.upsun.com/anchors/fixed/observability/integration/blackfire/",
  "links.observability-suite-blackfire.integrate":
    "https://docs.upsun.com/anchors/fixed/observability/integration/blackfire/setup/",
  "links.observability-suite-features": "https://upsun.com/product/",
  "links.platform.contact": "https://upsun.com/contact-us/",
  "links.pricing": "https://upsun.com/pricing/",
  "links.pricing.project_resources":
    "https://upsun.com/pricing/#project-resources",
  "links.privacy_policy":
    "https://upsun.com/trust-center/privacy/privacy-notice/",
  "links.sca.commision":
    "https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX%3A32018R0389",
  "links.sca.learnMore":
    "https://upsun.com/trust-center/legal/tos/#section-6-fees-and-term",
  "links.terms": "https://upsun.com/trust-center/legal/tos/",
  "links.tos": "https://upsun.com/trust-center/legal/tos/",
  "links.website": "https://upsun.com/"
};

export default links;
